import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { CaseTypeState } from '../../states/case-type.state';
import { DeleteCaseTypeResult } from './delete-case-type.result';

@Injectable({ providedIn: 'root' })
export class DeleteCaseTypeUseCase {
  private readonly _repository = inject(CaseTypeRepository);
  private readonly _state = inject(CaseTypeState);

  public execute(id: string): Observable<DeleteCaseTypeResult> {
    this._state.setDeletingCaseType(true);
    this._state.clearError();

    return this._repository.deleteCaseType(id).pipe(
      tap(() => {
        this._state.removeCaseType(id);
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setError(error?.error?.message || error?.message || 'Failed to delete case type');
        throw error;
      }),
      finalize(() => {
        this._state.setDeletingCaseType(false);
      }),
    );
  }
}
